<template>
  <div class="shape">

       <svg :id="id" :viewBox="viewBox" v-html="getShapeById(shape.plcId).shapeSource" xmlns="http://www.w3.org/2000/svg">
    </svg>
  </div>
</template>

<script>
/* eslint-disable */
import {v4 as uuidv4} from 'uuid'
import {mapGetters} from "vuex"

export default {
  name: "Shape",
  props: ['shape'],
  data() {
    return {
      viewBox: '0 0 100 100',
      id: ''
    }
  },
  computed:{
    ...mapGetters('shapes',['getShapeById']),

  },
  created() {
     this.id = uuidv4();
  },
  mounted() {
    // Adjust svg viewbox to its content
    const svg = document.getElementById(this.id);
    const bb = svg.getBBox();
    const bbx = bb.x - 1;
    const bby = bb.y - 1;
    const bbw = bb.width + 2;
    const bbh = bb.height + 2;
    const vb = [bbx, bby, bbw, bbh];
    this.viewBox = vb.join(' ');
  }
}
</script>

<style scoped>
.shape {
  width: 100%;
  height: 100%;
}

svg {
  height: inherit;
  width: inherit;
}

</style>
